import { render, staticRenderFns } from "./CalendarDashboardModuleContent.vue?vue&type=template&id=4895d712&scoped=true&"
import script from "./CalendarDashboardModuleContent.vue?vue&type=script&lang=js&"
export * from "./CalendarDashboardModuleContent.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDashboardModuleContent.vue?vue&type=style&index=0&id=4895d712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4895d712",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VChip,VIcon,VSelect,VSkeletonLoader,VTooltip})
